var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cluster_icon_purple_fliter_1",
    width: "126.1%",
    x: "-13%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cluster_icon_purple_fliter_2",
    width: "300%",
    height: "240%",
    x: "-100%",
    y: "-70%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.188,
    fillRule: "nonzero",
    d: "M19.547 31.931C13.62 31.43 8.954 26.041 8.954 19.47c0-6.904 5.15-12.5 11.5-12.5 6.352 0 11.5 5.596 11.5 12.5 0 5.863-3.713 10.783-8.724 12.133-.449.206-.786.422-1.012.647-.35.351-.729 1.024-1.133 2.018-.405-.994-.783-1.667-1.134-2.018a2.467 2.467 0 0 0-.404-.319zm1.445 5.037a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
    filter: "url(#cluster_icon_purple_fliter_1)",
    transform: "rotate(25 20.454 21.97)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD10E0",
    fillRule: "nonzero",
    d: "M11.565 29.605C4.936 28.052 0 22.102 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 7.102-4.936 13.052-11.565 14.605-.892.346-1.533.714-1.923 1.104-.468.468-.972 1.365-1.512 2.691-.54-1.326-1.044-2.223-1.512-2.69-.39-.391-1.031-.76-1.923-1.105zM15 36a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPurple);
export default __webpack_public_path__ + "static/media/icon_purple.c27180cf6c27b32ba24b2c49564b1fad.svg";
export { ForwardRef as ReactComponent };